import styled from '@emotion/styled';
import { CircularProgress } from '@mui/material';
import Autocomplete, { AutocompleteProps } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import * as React from 'react';

interface DropDownProperties<T> {
  options?: T[],
  value?: T | null | undefined,
  inputValue?: string | undefined
  open?: boolean | undefined
  hasSelectedItem?: boolean | undefined
}

const StyledDiv = styled.div({
  paddingInline: 20,
  paddingBlock: 10,
  cursor: 'pointer',
  '&:hover': {
    background: '#cecece',
    color: 'white',
  },
});

interface DropDownSearchComponentProps<T> extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  dataBuilder: (inputValue: string | undefined) => Promise<T[] | undefined>,
  onSelectItem?: (item: T) => void,
  onClear?: () => void,
  initInputValue?: string,
  label: string,
  modelLabelName: string,
  progress?: boolean,
  initData?: boolean,
}

export const DropDownSearchComponent = <T,>(props: DropDownSearchComponentProps<T>) => {
  const { dataBuilder, onSelectItem, onClear, initInputValue, label, modelLabelName, progress, initData, ...rest } = props

  const [dropDownProperties, setDropDownProperties] = React.useState<DropDownProperties<T> | undefined>({
    open: false,
    hasSelectedItem: false
  })

  React.useEffect(() => {
    if (props.initData)
      loadOptions()
  }, [])

  React.useEffect(() => {
    if (!dropDownProperties?.value && props.onClear)
      props.onClear()
  }, [dropDownProperties?.value])

  const loadOptions = async () => {
    const tmp = await props.dataBuilder(undefined)
    setDropDownProperties(prev => {
      return {
        ...prev,
        options: tmp || []
      }
    })
  }

  return <div
    {...rest}

    style={{
      position: 'relative',
      ...rest.style
    }}
  >
    {props.progress ? <CircularProgress size={25} style={{ position: 'absolute', top: 15, right: dropDownProperties?.hasSelectedItem ? 65 : 40, zIndex: 100000 }} /> : <></>}
    <Autocomplete
      noOptionsText="Digite o item desejado"
      open={dropDownProperties?.open}
      onOpen={() => setDropDownProperties(prev => {
        return {
          ...prev,
          open: true
        }
      })}
      onClose={() => setDropDownProperties(prev => {
        return {
          ...prev,
          open: false
        }
      })}
      onChange={(event: any, newValue: any) => {
        setDropDownProperties(prev => {
          return {
            ...prev,
            value: newValue
          }
        })

        if (!newValue)
          setDropDownProperties(prev => {
            return {
              ...prev,
              hasSelectedItem: false
            }
          })
      }}
      value={dropDownProperties?.value || null}
      inputValue={dropDownProperties?.inputValue || (dropDownProperties?.value ? ((dropDownProperties?.value as any)[props.modelLabelName] || props.initInputValue || '') : (props.initInputValue || ''))}
      onKeyDown={async (event) => {
        if (event.key === 'Enter' && !props.initData) {
          event.defaultPrevented = true;
          const tmp = await props.dataBuilder(dropDownProperties?.inputValue)
          setDropDownProperties(prev => {
            return {
              ...prev,
              options: tmp || []
            }
          })
        }
      }}

      // RENDERIZA O ITEM DA OPCAO
      renderOption={(tmp: any) => {
        return <>
          <StyledDiv
            key={tmp.id}
            onClick={() => {
              setDropDownProperties(prev => {
                return {
                  ...prev,
                  inputValue: tmp.key
                }
              })

              const valueTmp = dropDownProperties?.options?.filter((i: any) => i[props.modelLabelName] == tmp.key)[0] || dropDownProperties?.value
              setDropDownProperties(prev => {
                return {
                  ...prev,
                  value: valueTmp
                }
              })
              setDropDownProperties(prev => {
                return {
                  ...prev,
                  open: false
                }
              })
              setDropDownProperties(prev => {
                return {
                  ...prev,
                  hasSelectedItem: true
                }
              })
              if (props.onSelectItem && valueTmp)
                props.onSelectItem(valueTmp)
            }}>{tmp.key}</StyledDiv>
        </>
      }}
      isOptionEqualToValue={(option: any, value: any) => option[props.modelLabelName] === value[props.modelLabelName]}
      getOptionLabel={(option: any) => {
        return option[props.modelLabelName]
      }}
      onInputChange={async (event, newInputValue) => {
        setDropDownProperties(prev => {
          return {
            ...prev,
            inputValue: newInputValue
          }
        })
      }}
      id="controllable-states-demo"
      options={dropDownProperties?.options || []}
      renderInput={(params) => <TextField {...params} label={props.label}/>}
    />
  </div>
}
